/**
 * Покриття аналізом модуля «Бізнес-аналіз» (прототип v4 isBaDash; BA_SYS, BA_KINDS, COLS): ключ модуля аналізу всієї платформи, системні
 * рядки матриці перед модулями простору, види записів у стовпцях матриці, статуси виконаної вимоги й види таблиці «Зацікавлені сторони».
 */
export const BA_COVERAGE = {
  module: 'ba',
  systemRows: ['Platform', 'Home', 'Administration', 'Customization'],
  matrixKinds: ['Problem', 'Risk', 'Opportunity', 'Stakeholder need', 'Use case', 'Requirement'],
  requirement: 'Requirement',
  doneStatuses: ['Implemented', 'Verified'],
  stakeKinds: ['Stakeholder need', 'Use case', 'Requirement'],
} as const;
